import reducer from './ui.reducer';
import actions from './ui.actions';
import selectors from './ui.selectors';

export default {
  reducer,
  actions,
  selectors,
};
